import { DARK, LIGHT } from "./theme";
import { useState, useEffect } from "react";
import { setToken, clearToken } from "./api";
import Login from "./components/Login";
import Sidebar from "./components/Sidebar";
import CredentialList from "./components/CredentialList";
import Generator, { generatePassword } from "./components/Generator";
import AdminPanel from "./components/AdminPanel";
import { api } from "./api";
import Communications from "./components/Communications";
import AuditLog from "./components/AuditLog";
import Skills from "./components/Skills";
import PrivateVault from "./components/PrivateVault";
import Calendar from "./components/Calendar";
import Settings from "./components/Settings";
import Backup from "./components/Backup";

const USERS = [
  { id: 1, name: "Javier Arquillo",    email: "info@objetivabroker.com",       role: "admin",    avatar: "JA", color: "#8B6914", dept: "Administrador" },
  { id: 3, name: "Javier Segura",      email: "jsegura@objetivabroker.com",    role: "employee", avatar: "JS", color: "#8B6914", dept: "Comercial" },
  { id: 4, name: "Susana Pierre",      email: "spierre@objetivabroker.com",    role: "employee", avatar: "SP", color: "#00ffe7", dept: "IT" },
];

const CATEGORIES = ["Aseguradoras", "Software interno", "Comunicación", "Gestiones", "Interno", "Otros"];

// Limpia espacios y caracteres invisibles al principio/final
const cleanName = (s) => (s || "").replace(/^[\s\u200B-\u200D\u2060\uFEFF]+|[\s\u200B-\u200D\u2060\uFEFF]+$/g, "");

// Capitaliza cada palabra (Título)
const titleCase = (s) => cleanName(s).toLowerCase().replace(/(^|\s)\p{L}/gu, (m) => m.toUpperCase());

const LOGS = [
  { user: "Javier Arquillo",    action: "Añadió credencial",  item: "Avant (Tarificador)", time: "Hoy 09:12" },
  { user: "Ingrid Castellanos", action: "Consultó contraseña", item: "Email Producción",   time: "Hoy 09:45" },
  { user: "Susana Pierre",      action: "Añadió credencial",  item: "Impresora Brother",   time: "Hoy 10:03" },
];

/* ── Design tokens ── */
const T = {
  bg:       "#0F0A06",
  bgApp:    "#1A1208",
  sidebar:  "#120D06",
  card:     "#241A0E",
  lift:     "#2E2010",
  border:   "#3D2E18",
  gold:     "#C9A870",
  goldDim:  "#A88040",
  goldHi:   "#E8D5A3",
  cream:    "#F2EFE9",
  mute:     "#8A7458",
  text:     "#E8D8B8",
  textSub:  "#B8986A",
  input:    "#241A0E",
  ok:       "#2A9D6A",
  hover:    "#2E2010",
  sec:      "#9A8A78",
  err:      "#8B3A3A",
  r:        "8px",
};


/* ── Helpers ── */
function strengthScore(pwd) {
  if (!pwd) return 0;
  let s = 0;
  if (pwd.length >= 8)          s++;
  if (pwd.length >= 14)         s++;
  if (/[A-Z]/.test(pwd))        s++;
  if (/[0-9]/.test(pwd))        s++;
  if (/[^A-Za-z0-9]/.test(pwd)) s++;
  return s;
}
const strengthColor = ["", "#e74c3c", "#e67e22", "#f1c40f", "#2ecc71", "#27ae60"];
const strengthLabel = ["", "Muy débil", "Débil", "Regular", "Fuerte", "Muy fuerte"];

const Icon = ({ d, size = 16, stroke = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const EyeIcon = ({ open }) => open
  ? <Icon d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
  : <Icon d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22" />;

/* ── Mini logo SVG for sidebar ── */
const LogoMark = ({ gold = "#C9A870", bg = "#080808" }) => (
  <svg viewBox="-20 -20 240 240" width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="100" cy="100" r="115" stroke="#7A6040" strokeWidth="0.8"/>
    <line x1="100" y1="-15"  x2="100" y2="-28"  stroke={gold} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="100" y1="215"  x2="100" y2="228"  stroke={gold} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="-15" y1="100"  x2="-28" y2="100"  stroke={gold} strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="215" y1="100"  x2="228" y2="100"  stroke={gold} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="100" cy="100" r="95" fill={bg} fillOpacity="0.9"/>
    <polygon points="100,30 153,62.5 153,137.5 100,170 47,137.5 47,62.5" stroke={gold} strokeWidth="1.8" fill={bg}/>
    <polygon points="100,42 143,67 143,133 100,158 57,133 57,67" stroke="#7A6040" strokeWidth="0.9" fill="none"/>
    <circle cx="100" cy="88" r="22" stroke={gold} strokeWidth="1.8" fill={bg}/>
    <rect x="89" y="107" width="22" height="32" fill={bg}/>
    <line x1="89"  y1="107" x2="89"  y2="139" stroke={gold} strokeWidth="1.8"/>
    <line x1="111" y1="107" x2="111" y2="139" stroke={gold} strokeWidth="1.8"/>
    <line x1="89"  y1="139" x2="111" y2="139" stroke={gold} strokeWidth="1.8"/>
  </svg>
);

/* ══════════════════════════════════════════════
   SIDEBAR
══════════════════════════════════════════════ */
function AppSidebar({ currentUser, view, setView, onLogout, theme, onToggleTheme, T, sidebarOpen, setSidebarOpen, isMobile }) {
  const navItems = [
    { id: "shared",    label: "Bóveda Compartida", icon: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" },
    { id: "personal",  label: "Mi Bóveda",          icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" },
    { id: "comms", label: "Comunicaciones", icon: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" },
    { id: "skills", label: "Conocimiento", icon: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" },
    { id: "settings", label: "Configuración", icon: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7.07-1.06l1.41-1.41-1.41-1.41-1.41 1.41a7 7 0 0 0-2.12-1.22V9h-2v1.31a7 7 0 0 0-2.12 1.22L9.93 10.1 8.51 11.51l1.41 1.41A7 7 0 0 0 9 15v2h2v-2a5 5 0 0 1 10 0v2h2v-2a7 7 0 0 0-.93-3.06z" },
    { id: "audit", label: "Auditoría", icon: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2" },
    { id: "calendar", label: "Calendario", icon: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z" },
    { id: "backup", label: "Copia de Seguridad", icon: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" },
    { id: "generator", label: "Generador",           icon: "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" },
    ...(currentUser.role === "admin"
      ? [{ id: "private_vault", label: "Bóveda Privada 🔒", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" },
          { id: "admin", label: "Administración", icon: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" }]
      : []),
  ];

  return (
    <aside style={{ ...S.sidebar, transform: isMobile && !sidebarOpen ? "translateX(-100%)" : "translateX(0)", zIndex: isMobile ? 200 : 1, background: "var(--sidebar)" }}>
      {/* Botón cerrar en móvil */}
      <button onClick={() => setSidebarOpen(false)} style={{ display: "none", position: "absolute", top: 10, right: 10, background: "none", border: "none", color: "var(--mute)", fontSize: 18, cursor: "pointer" }} className="mob-close">✕</button>
      {/* Logo */}
      <div style={S.logoWrap}>
        <LogoMark gold={T.gold} bg={T.sidebar} />
        <div style={{ lineHeight: 1 }}>
          <div style={S.logoName}>
            <span style={{ color: "var(--gold)" }}>OBJ</span><span style={{ color: "var(--text)" }}> CLA</span><span style={{ color: "var(--gold)" }}>VEX</span>
          </div>
        </div>
      </div>

      {/* User pill */}
      <div style={S.userPill}>
        <div style={{ ...S.avatar, borderColor: "var(--goldDim)", color: currentUser.color || "var(--gold)" }}>
          {currentUser.avatar}
        </div>
        <div style={{ overflow: "hidden" }}>
          <div style={S.userName}>{currentUser.name}</div>
          <div style={S.userRole}>{currentUser.dept}</div>
        </div>
      </div>

      {/* Nav */}
      <nav style={S.nav}>
        {navItems.filter(item => !item.adminOnly || currentUser.role === "admin").map(item => (
          <button key={item.id}
            onClick={() => setView(item.id)}
            style={{ ...S.navItem, ...(view === item.id ? S.navItemActive : {}) }}>
            <span style={{ ...S.navDot, background: view === item.id ? "var(--gold)" : "var(--goldDim)" }} />
            <Icon d={item.icon} size={14} />
            {item.label}
          </button>
        ))}
      </nav>

      {/* Footer */}
      <div style={S.sidebarFooter}>
        <button onClick={onToggleTheme} style={{ ...S.logoutBtn, marginBottom: 6, borderColor: "var(--goldDim)", color: "var(--goldDim)" }}>
          {theme === "dark" ? "☀ Modo claro" : "☾ Modo oscuro"}
        </button>
        <button onClick={onLogout} style={S.logoutBtn}>
          <Icon d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" size={13} />
          Cerrar sesión
        </button>
      </div>
    </aside>
  );
}

/* ══════════════════════════════════════════════
   CREDENTIAL CARD (expandable)
══════════════════════════════════════════════ */
function CredCard({ cred, revealed, copied, onReveal, onCopy, onDelete, onEdit, canDelete }) {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editData, setEditData] = useState({});

  const startEdit = (e) => {
    e.stopPropagation();
    setEditData({ name: cred.name, url: cred.url || "", username: cred.username || "", password: cred.password, category: cred.category, notes: cred.notes || "" });
    setEditing(true);
  };
  const saveEdit = () => { onEdit(cred.id, editData); setEditing(false); };
  const score = strengthScore(cred.password);

  return (
    <div style={{ ...S.credCard, ...(open ? { borderColor: "#2A2010" } : {}) }}>
      {/* Header row */}
      <div style={{ ...S.credHeader, ...(open ? { borderBottom: "0.5px solid var(--border)" } : {}) }}
           onClick={() => setOpen(o => !o)}>
        <div style={S.credIcon}>
          <Icon d={
            cred.category === "Aseguradoras" ? "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0 1 12 2.944a11.955 11.955 0 0 1-8.618 3.04A12.02 12.02 0 0 0 3 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" :
            cred.category === "Software interno" ? "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18" :
            cred.category === "Comunicación" ? "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" :
            cred.url ? "M13.828 10.172a4 4 0 0 0-5.656 0l-4 4a4 4 0 1 0 5.656 5.656l1.102-1.101" :
            "M15 7a2 2 0 0 1 2 2m4 0a6 6 0 0 1-7.743 5.743L11 17H9v2H7v2H4a1 1 0 0 1-1-1v-2.586a1 1 0 0 1 .293-.707l5.964-5.964A6 6 0 1 1 21 9z"
          } size={16} stroke="var(--gold)" />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={S.credName}>{titleCase(cred.name)}</div>
          <div style={S.credMeta}>{cred.username || cred.url || cred.category}</div>
        </div>
        {/* Strength pip */}
        <div style={{
          width: 7, height: 7, borderRadius: "50%", flexShrink: 0,
          background: score ? strengthColor[score] : "var(--border)",
        }} title={strengthLabel[score]} />
        {/* Category tag */}
        {cred.category && (
          <span style={S.catTag}>{cred.category}</span>
        )}
        <span style={{ fontSize: 9, color: "var(--mute)", marginLeft: 4 }}>{open ? "▲" : "▼"}</span>
      </div>

      {/* Expanded body */}
      {open && (
        <div style={S.credBody}>
          {cred.url && (
            <div style={S.credRow}>
              <span style={S.credLabel}>URL</span>
              <span style={{ ...S.credVal, color: "var(--textSub)" }}>{cred.url}</span>
            </div>
          )}
          {cred.username && (
            <div style={S.credRow}>
              <span style={S.credLabel}>Usuario</span>
              <span style={S.credVal}>{cred.username}</span>
              <button style={S.iconBtn} onClick={() => onCopy(cred.username, `u-${cred.id}`)}>
                {copied === `u-${cred.id}`
                  ? <Icon d="M20 6L9 17l-5-5" size={14} stroke={T.ok} />
                  : <Icon d="M8 16H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2M16 8h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2" size={14} />}
              </button>
            </div>
          )}
          <div style={S.credRow}>
            <span style={S.credLabel}>Contraseña</span>
            <span style={{ ...S.credVal, fontFamily: "Jura, monospace", letterSpacing: revealed[cred.id] ? 2 : 1 }}>
              {revealed[cred.id] ? cred.password : "••••••••••••"}
            </span>
            <button style={S.iconBtn} onClick={() => onReveal(cred.id)}>
              <EyeIcon open={revealed[cred.id]} />
            </button>
            <button style={S.iconBtn} onClick={() => onCopy(cred.password, `p-${cred.id}`)}>
              {copied === `p-${cred.id}`
                ? <Icon d="M20 6L9 17l-5-5" size={14} stroke={T.ok} />
                : <Icon d="M8 16H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2M16 8h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2" size={14} />}
            </button>
          </div>
          {/* Strength bar */}
          <div style={{ ...S.credRow, alignItems: "center", gap: 6 }}>
            <span style={S.credLabel}>Fortaleza</span>
            <div style={{ display: "flex", gap: 3 }}>
              {[1,2,3,4,5].map(i => (
                <div key={i} style={{ width: 22, height: 3, borderRadius: 2,
                  background: i <= score ? strengthColor[score] : T.border }} />
              ))}
            </div>
            <span style={{ fontSize: 10, color: score ? strengthColor[score] : T.mute, fontFamily: "Plus Jakarta Sans, sans-serif", letterSpacing: 1 }}>
              {strengthLabel[score] || "—"}
            </span>
          </div>
          {cred.notes && (
            <div style={S.credRow}>
              <span style={S.credLabel}>Notas</span>
              <span style={{ ...S.credVal, fontSize: 12 }}>{cred.notes}</span>
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, paddingTop: 8 }}>
            <button style={{ ...S.deleteBtn, background: "var(--lift)", borderColor: "var(--goldDim)", color: "var(--gold)" }} onClick={startEdit}>
              <Icon d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" size={13} />
              Editar
            </button>
            {(typeof canDelete === "function" ? canDelete(cred) : canDelete) && (
              <button style={S.deleteBtn} onClick={() => onDelete(cred.id)}>
                <Icon d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" size={13} />
                Eliminar
              </button>
            )}
          </div>
          {editing && (
            <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.8)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 }}>
              <div style={{ background: "var(--card)", border:"0.5px solid var(--border)", borderRadius:8, padding:"2rem", width:400, display:"flex", flexDirection:"column", gap:12 }}>
                <div style={{ fontFamily:"Syne,sans-serif", fontSize:"1.1rem", color:"var(--text)", marginBottom:4 }}>Editar credencial</div>
                {["name","url","username","password","notes"].map(f => (
                  <div key={f} style={{ display:"flex", flexDirection:"column", gap:4 }}>
                    <label style={{ fontSize:10, color:"var(--gold)", letterSpacing:"0.1em", textTransform:"uppercase" }}>{f}</label>
                    <input value={editData[f]||""} onChange={e=>setEditData(d=>({...d,[f]:e.target.value}))}
                      style={{ background:"var(--lift)", border:"0.5px solid var(--border)", color:"var(--text)", padding:"0.5rem 0.75rem", borderRadius:4, fontFamily:"Instrument Sans,sans-serif", fontSize:13 }} />
                  </div>
                ))}
                <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:8 }}>
                  <button onClick={()=>setEditing(false)} style={{ ...S.deleteBtn, background:"transparent" }}>Cancelar</button>
                  <button onClick={saveEdit} style={{ ...S.deleteBtn, background:"var(--gold)", color:"var(--bgApp)", borderColor:"var(--gold)" }}>Guardar</button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function AppCredentialList({ items, revealed, copied, onReveal, onCopy, onDelete, onEdit, canDelete }) {
  if (!items.length) return (
    <div style={S.emptyState}>
      <div style={{ fontSize: 32, marginBottom: 12 }}>🔐</div>
      <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 11, letterSpacing: 2, color: T.mute, textTransform: "uppercase" }}>
        Sin credenciales
      </div>
    </div>
  );
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {[...items].sort((a, b) => cleanName(a.name).localeCompare(cleanName(b.name), "es", { sensitivity: "base" })).map(c => (
        <CredCard key={c.id} cred={c} revealed={revealed} copied={copied}
          onReveal={onReveal} onCopy={onCopy} onDelete={onDelete} onEdit={onEdit} canDelete={canDelete} />
      ))}
    </div>
  );
}

/* ══════════════════════════════════════════════
   ADD CREDENTIAL FORM
══════════════════════════════════════════════ */
function AddCredForm({ data, onChange, onSubmit, onClose }) {
  const [showPwd, setShowPwd] = useState(false);
  const score = strengthScore(data.password);
  const set = (k, v) => onChange({ ...data, [k]: v });

  const fields = [
    { label: "Nombre *",       key: "name",     placeholder: "ej. Portal Mutua Madrileña" },
    { label: "URL",            key: "url",      placeholder: "https://..." },
    { label: "Usuario / Email",key: "username", placeholder: "" },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {fields.map(f => (
        <div key={f.key}>
          <label style={S.formLabel}>{f.label}</label>
          <input value={data[f.key]} onChange={e => set(f.key, e.target.value)}
            placeholder={f.placeholder} style={S.formInput} />
        </div>
      ))}

      <div>
        <label style={S.formLabel}>Contraseña *</label>
        <div style={{ display: "flex", gap: 8 }}>
          <div style={{ flex: 1, position: "relative" }}>
            <input type={showPwd ? "text" : "password"} value={data.password}
              onChange={e => set("password", e.target.value)}
              style={{ ...S.formInput, paddingRight: 38, letterSpacing: showPwd ? 1 : 3 }} />
            <button onClick={() => setShowPwd(s => !s)} style={S.eyeBtn}>
              <EyeIcon open={showPwd} />
            </button>
          </div>
          <button onClick={() => set("password", generatePassword(16))} style={S.genBtn} title="Generar">↻</button>
        </div>
        {data.password && (
          <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 8 }}>
            {[1,2,3,4,5].map(i => (
              <div key={i} style={{ flex: 1, height: 3, borderRadius: 2,
                background: i <= score ? strengthColor[score] : T.border }} />
            ))}
            <span style={{ fontSize: 10, color: strengthColor[score], marginLeft: 6,
              fontFamily: "Plus Jakarta Sans, sans-serif", letterSpacing: 1 }}>
              {strengthLabel[score]}
            </span>
          </div>
        )}
      </div>

      <div>
        <label style={S.formLabel}>Categoría</label>
        <select value={data.category} onChange={e => set("category", e.target.value)} style={S.formInput}>
          {CATEGORIES.map(c => <option key={c}>{c}</option>)}
        </select>
      </div>

      <div>
        <label style={S.formLabel}>Notas</label>
        <textarea value={data.notes} onChange={e => set("notes", e.target.value)}
          rows={2} style={{ ...S.formInput, resize: "vertical" }} />
      </div>

      <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
        <button onClick={onClose} style={S.cancelBtn}>Cancelar</button>
        <button onClick={onSubmit} style={{ ...S.addBtn, flex: 1, justifyContent: "center" }}>
          Guardar credencial
        </button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   MODAL
══════════════════════════════════════════════ */
function Modal({ title, children, onClose }) {
  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={S.modal}>
        <div style={S.modalHeader}>
          <div>
            <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 9, letterSpacing: 3,
              color: "var(--goldDim)", textTransform: "uppercase", marginBottom: 4 }}>
              Clavex · Objetiva Broker
            </div>
            <span style={S.modalTitle}>{title}</span>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none",
            color: "var(--mute)", cursor: "pointer", fontSize: 18, lineHeight: 1 }}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   TOAST
══════════════════════════════════════════════ */
function Toast({ msg }) {
  return (
    <div style={S.toast}>{msg}</div>
  );
}

/* ══════════════════════════════════════════════
   APP ROOT
══════════════════════════════════════════════ */
export default function App() {
  const [currentUser, setCurrentUser]   = useState(null);
  const [theme, setTheme]               = useState("dark");
  const [restoring, setRestoring]       = useState(true);
  const T = theme === "dark" ? DARK : LIGHT;
  useEffect(() => {
    const root = document.documentElement;
    Object.entries(T).forEach(([k, v]) => root.style.setProperty(`--${k}`, v));
    root.style.setProperty("--font", "'Plus Jakarta Sans', sans-serif");
  }, [T]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Restaurar sesión al montar
  useEffect(() => {
    const restoreSession = async () => {
      try {
        const r = await fetch("https://clavex.objetivabroker.es/api/auth/refresh", {
          method: "POST",
          credentials: "include",
        });
        if (r.ok) {
          const data = await r.json();
          setToken(data.access_token);
          const r2 = await fetch("https://clavex.objetivabroker.es/api/auth/me", {
            headers: { Authorization: `Bearer ${data.access_token}` },
          });
          if (r2.ok) {
            const user = await r2.json();
            setCurrentUser(user);
            setTheme(user.theme || "dark");
          }
        }
      } catch {}
      setRestoring(false);
    };
    restoreSession();
  }, []);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  // Auto-logout por inactividad (15 min)
  useEffect(() => {
    if (!currentUser) return;
    let timer;
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        await api.logout();
        clearToken();
        setCurrentUser(null); setSharedVault([]); setPersonalVault([]);
      }, 15 * 60 * 1000);
    };
    const events = ["mousemove", "keydown", "click", "touchstart", "scroll"];
    events.forEach(e => window.addEventListener(e, reset));
    reset();
    return () => {
      clearTimeout(timer);
      events.forEach(e => window.removeEventListener(e, reset));
    };
  }, [currentUser]);
  const [view, setView]                 = useState("shared");
  const [viewHistory, setViewHistory]   = useState([]);

  const navigate = (newView) => {
    setViewHistory(h => [...h, view]);
    setView(newView);
  };
  const navigateFromSidebar = (newView) => {
    setViewHistory([]);
    setView(newView);
    setSidebarOpen(false);
  };
  const goBack = () => {
    if (viewHistory.length === 0) return;
    const prev = viewHistory[viewHistory.length - 1];
    setViewHistory(h => h.slice(0, -1));
    setView(prev);
  };
  const [sharedVault, setSharedVault]   = useState([]);
  const [personalVault, setPersonalVault] = useState([]);
  const [revealedPwds, setRevealedPwds] = useState({});
  const [copied, setCopied]             = useState(null);
  const [search, setSearch]             = useState("");
  const [filterCat, setFilterCat]       = useState("Todas");
  const [showAddModal, setShowAddModal] = useState(false);
  const [dupWarn, setDupWarn] = useState(null);
  const [addTarget, setAddTarget]       = useState("personal");
  const [newCred, setNewCred]           = useState({ name: "", url: "", username: "", password: "", category: "Otros", notes: "" });
  const [genLen, setGenLen]             = useState(16);
  const [genPwd, setGenPwd]             = useState(generatePassword(16));
  const [toast, setToast]               = useState(null);
  const [loading, setLoading]           = useState(false);

  useEffect(() => { if (currentUser) loadVaults(); }, [currentUser]);

  const loadVaults = async () => {
    setLoading(true);
    try {
      const [shared, personal] = await Promise.all([api.getShared(), api.getPersonal()]);
      setSharedVault(shared);
      setPersonalVault(personal);
    } catch { showToast("Error cargando bóveda"); }
    finally  { setLoading(false); }
  };

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2200); };

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text).then(() => { setCopied(id); setTimeout(() => setCopied(null), 1500); });
    showToast("Copiado al portapapeles ✓");
  };

  const toggleReveal = (id) => setRevealedPwds(p => ({ ...p, [id]: !p[id] }));

  const filteredShared = sharedVault.filter(c =>
    (filterCat === "Todas" || c.category === filterCat) &&
    (c.name.toLowerCase().includes(search.toLowerCase()) || (c.username || "").toLowerCase().includes(search.toLowerCase()))
  ).sort((a, b) => cleanName(a.name).localeCompare(cleanName(b.name), "es", { sensitivity: "base" }));
  const filteredPersonal = personalVault.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase())
  ).sort((a, b) => cleanName(a.name).localeCompare(cleanName(b.name), "es", { sensitivity: "base" }));

  const handleAddCred = async (forzar) => {
    const force = forzar === true;
    if (!newCred.name || !newCred.password) { showToast("Nombre y contraseña son obligatorios"); return; }
    try {
      if (addTarget === "shared") await api.addShared(newCred, force);
      else                        await api.addPersonal(newCred, force);
      await loadVaults();
      setNewCred({ name: "", url: "", username: "", password: "", category: "Otros", notes: "" });
      setDupWarn(null);
      setShowAddModal(false);
      showToast("Credencial guardada ✓");
    } catch (e) {
      if (e.status === 409 && e.detail && e.detail.code === "duplicate") { setDupWarn(e.detail); return; }
      showToast(e.message || "Error guardando credencial");
    }
  };
  const irAExistente = () => {
    setSearch(dupWarn.name);
    setView(addTarget === "shared" ? "shared" : "personal");
    setDupWarn(null);
    setShowAddModal(false);
  };

  const editShared   = async (id, data) => { try { await api.updateShared(id, data);   await loadVaults(); showToast("Credencial actualizada ✓"); } catch (e) { showToast(e.message || "Error"); } };
  const editPersonal = async (id, data) => { try { await api.updatePersonal(id, data); await loadVaults(); showToast("Credencial actualizada ✓"); } catch (e) { showToast(e.message || "Error"); } };
  const deleteShared   = async (id) => { try { await api.deleteShared(id);   setSharedVault(v => v.filter(c => c.id !== id));   showToast("Eliminada"); } catch (e) { showToast(e.message || "Error"); } };
  const deletePersonal = async (id) => { try { await api.deletePersonal(id); setPersonalVault(v => v.filter(c => c.id !== id)); showToast("Eliminada"); } catch (e) { showToast(e.message || "Error"); } };

  const handleLogout = async () => {
    await api.logout();
    setCurrentUser(null); setSharedVault([]); setPersonalVault([]);
  };

  /* Login screen */
  if (restoring) return <div style={{ minHeight: "100vh", background: "#0D0B08" }} />;
  if (!currentUser) return <Login onLogin={user => { setCurrentUser(user); setTheme(user.theme || "dark"); setView("shared"); }} />;

  const viewTitles = {
    shared:    { eyebrow: "Acceso equipo",   h1: "Bóveda Compartida" },
    personal:  { eyebrow: "Solo tú",         h1: "Mi Bóveda Personal" },
    generator: { eyebrow: "Seguridad",       h1: "Generador de Contraseñas" },
    audit:     { eyebrow: null,              h1: null },
    calendar:  { eyebrow: "Equipo",          h1: "Calendario" },
    admin:     { eyebrow: "Gestión",         h1: "Panel de Administración" },
    comms:     { eyebrow: null,              h1: null },
    skills:    { eyebrow: null,              h1: null },
    private_vault: { eyebrow: null, h1: null },
    settings:  { eyebrow: null,              h1: null },
  };

  const isVaultView = view === "shared" || view === "personal";
  const canAdd      = true;

  return (
    <div style={{ ...S.app,
      "--bg": T.bg, "--bgApp": T.bgApp, "--card": T.card, "--border": T.border,
      "--gold": T.gold, "--goldDim": T.goldDim, "--cream": T.cream, "--mute": T.mute,
      "--text": T.text, "--textSub": T.textSub, "--input": T.input,
      "--lift": T.lift, "--chip": T.chip, "--chipText": T.chipText,
"--sidebar": T.sidebar, "--hover": T.hover,
      background: T.bgApp, color: T.text, transition: "background 0.3s, color 0.3s"
    }}>
      
      {isMobile && sidebarOpen && <div onClick={() => setSidebarOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 99 }} />}
      <AppSidebar currentUser={currentUser} view={view} setView={navigateFromSidebar} onLogout={handleLogout} theme={theme} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} isMobile={isMobile} onToggleTheme={() => { const next = theme === "dark" ? "light" : "dark"; setTheme(next); fetch(`${window.location.protocol}//${window.location.host}/api/auth/theme`, { method: "PATCH", headers: {"Content-Type":"application/json"}, body: JSON.stringify({ email: currentUser.email, theme: next }) }).catch(()=>{}); }} T={T} />

      <main style={{ ...S.main, background: T.bgApp, color: T.text, marginLeft: isMobile ? 0 : 221, padding: isMobile ? '60px 16px 24px' : '32px 40px' }}>
        {/* Hamburger móvil */}
        {isMobile && <button onClick={() => setSidebarOpen(o => !o)} style={{ position: "fixed", top: 12, left: 12, zIndex: 200, background: "var(--card)", border: "1px solid var(--border)", borderRadius: 6, padding: "6px 10px", cursor: "pointer", color: "var(--gold)", fontSize: 18 }}>☰</button>}
        {/* Botón volver — siempre excepto Bóveda Compartida */}
        {view !== "shared" && (
          <div style={{ marginBottom: 8 }}>
            <button onClick={() => { setViewHistory([]); setView("shared"); }}
              style={{ background: "none", border: "none", color: "var(--goldDim)", cursor: "pointer", fontFamily: "Syne, sans-serif", fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase", padding: 0, display: "flex", alignItems: "center", gap: 6 }}>
              ← Volver
            </button>
          </div>
        )}

        {/* Page header — solo si la vista tiene título */}
        {viewTitles[view]?.h1 && (
        <div style={S.pageHeader}>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div>
              {viewTitles[view]?.eyebrow && <div style={S.pageEyebrow}>{viewTitles[view].eyebrow}</div>}
              <h1 style={S.pageH1}>{viewTitles[view].h1}</h1>
            </div>
          </div>
          {isVaultView && (
            <button
              onClick={() => { if (!canAdd) return; setAddTarget(view === "shared" ? "shared" : "personal"); setShowAddModal(true); }}
              style={{ ...S.addBtn, ...(canAdd ? {} : { opacity: 0.3, cursor: "not-allowed" }) }}
              disabled={!canAdd}>
              + Añadir
            </button>
          )}
        </div>
        )}

        {loading && (
          <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 11, letterSpacing: 2,
            color: T.goldDim, textTransform: "uppercase" }}>
            Cargando bóveda...
          </div>
        )}

        {/* Search + filters */}
        {isVaultView && (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={S.searchWrap}>
              <Icon d="M21 21l-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0" size={15} stroke="var(--mute)" />
              <input value={search} onChange={e => setSearch(e.target.value)}
                placeholder="Buscar credenciales..." style={S.searchInput} />
            </div>
            {view === "shared" && (
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {["Todas", ...CATEGORIES].map(c => (
                  <button key={c} onClick={() => setFilterCat(c)}
                    style={{ ...S.chip, ...(filterCat === c ? S.chipActive : {}) }}>
                    {c}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Content */}
        {isVaultView && (
          <AppCredentialList
            items={view === "shared" ? filteredShared : filteredPersonal}
            revealed={revealedPwds} copied={copied}
            onReveal={toggleReveal} onCopy={copyToClipboard}
            onEdit={view === "shared" ? editShared : editPersonal}
            onDelete={view === "shared" ? deleteShared : deletePersonal}
            canDelete={view === "shared" ? (cred) => currentUser.role === "admin" || cred.added_by === currentUser.id : () => true}
          />
        )}

        {view === "comms" && (
          <Communications currentUser={currentUser} />
        )}
        {view === "audit" && <AuditLog />}
        {view === "skills" && <Skills user={currentUser} />}
        {view === "private_vault" && currentUser.role === "admin" && <PrivateVault user={currentUser} />}
        {view === "calendar" && <Calendar user={currentUser} />}
        {view === "settings" && <Settings user={currentUser} onUpdate={setCurrentUser} />}
        {view === "generator" && (
          <Generator genLen={genLen} setGenLen={setGenLen} genPwd={genPwd} setGenPwd={setGenPwd} onCopy={copyToClipboard} />
        )}

        {view === "backup" && <Backup theme={theme} />}
        {view === "admin" && currentUser.role === "admin" && (
          <AdminPanel users={USERS} sharedVault={sharedVault} personalVault={personalVault} logs={LOGS} />
        )}
      </main>

      {/* Add modal */}
      {showAddModal && (
        <Modal
          title={`Añadir a ${addTarget === "shared" ? "Bóveda Compartida" : "Mi Bóveda"}`}
          onClose={() => setShowAddModal(false)}>
          <AddCredForm data={newCred} onChange={setNewCred} onSubmit={handleAddCred} onClose={() => setShowAddModal(false)} />
        </Modal>
      )}

      {dupWarn && (
        <Modal title="Esta credencial ya existe" onClose={() => setDupWarn(null)}>
          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <div style={{ fontSize: 13, lineHeight: 1.6, color: "var(--text)" }}>
              Ya hay una credencial guardada con este nombre y usuario:
            </div>
            <div style={{ padding: "12px 14px", background: "var(--bg)", border: "0.5px solid var(--border)", borderRadius: 8 }}>
              <div style={{ fontSize: 14, fontWeight: 600 }}>{dupWarn.name}</div>
              <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>
                {dupWarn.username ? dupWarn.username : "(sin usuario)"}
              </div>
            </div>
            <div style={{ fontSize: 13, lineHeight: 1.6, color: "var(--text)" }}>
              ¿Qué quieres hacer?
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <button onClick={irAExistente}
                style={{ padding: "11px 16px", borderRadius: 8, border: "0.5px solid var(--border)", background: "var(--gold, #C9A870)", color: "#0E0C09", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
                Editar la que ya existe
              </button>
              <button onClick={() => { setDupWarn(null); handleAddCred(true); }}
                style={{ padding: "11px 16px", borderRadius: 8, border: "0.5px solid var(--border)", background: "transparent", color: "var(--text)", fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>
                Crear una nueva de todas formas
              </button>
              <button onClick={() => setDupWarn(null)}
                style={{ padding: "11px 16px", borderRadius: 8, border: "none", background: "transparent", color: "var(--text)", opacity: 0.6, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>
                Cancelar y volver al formulario
              </button>
            </div>
          </div>
        </Modal>
      )}
      {toast && <Toast msg={toast} />}
    </div>
  );
}

/* ══════════════════════════════════════════════
   STYLES
══════════════════════════════════════════════ */
const S = {
  /* Layout */
  app:    { display: "flex", height: "100vh", background: "var(--bg)", color: "var(--text)",
            fontFamily: "'Plus Jakarta Sans', sans-serif", overflow: "hidden" },
  main:   { marginLeft: 221, flex: 1, overflow: "auto", padding: "32px 40px",
            display: "flex", flexDirection: "column", gap: 28 },

  /* Sidebar */
  sidebar: { width: 220, background: "var(--sidebar)", transition: "transform 0.25s ease", backdropFilter: "none", WebkitBackdropFilter: "none", isolation: "isolate", 
             borderRight: "1px solid var(--border)",
             boxShadow: "6px 0 24px rgba(0,0,0,0.5), 2px 0 6px rgba(0,0,0,0.3)",
             display: "flex", flexDirection: "column", padding: "0",
             flexShrink: 0, position: "fixed", top: 0, left: 0, bottom: 0 },
  logoWrap: { display: "flex", alignItems: "center", gap: 10,
              padding: "16px 16px 4px", borderBottom: "none", marginBottom: 0 },
  logoName: { fontFamily: "Syne, sans-serif", fontSize: 15, fontWeight: 700,
              letterSpacing: "0.08em", color: "var(--text)" },
  logoSub:  { fontFamily: "Syne, sans-serif", fontSize: 8, letterSpacing: "0.18em",
              color: "var(--mute)", marginTop: 3, textTransform: "uppercase" },
  userPill: { display: "flex", alignItems: "center", gap: 10,
              margin: "12px 10px", padding: "10px 12px",
              background: "var(--card)", 
              borderRadius: "8px",
              borderLeft: "3px solid var(--gold)",
              border: "0.5px solid var(--border)",
              borderLeftWidth: "3px",
              borderLeftColor: "var(--gold)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.18), 0 1px 3px rgba(0,0,0,0.12)" },
  avatar:   { width: 28, height: 28, borderRadius: "50%", background: "var(--card)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 10, fontWeight: 700, letterSpacing: 0.5, flexShrink: 0 },
  userName: { fontFamily: "Syne, sans-serif", fontSize: 11, fontWeight: 700, color: "var(--text)",
              whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  userRole: { fontFamily: "Syne, sans-serif", fontSize: 9, letterSpacing: "0.06em",
              color: "var(--gold)", textTransform: "uppercase", marginTop: 2 },
  nav:      { flex: 1, padding: "4px 0", display: "flex", flexDirection: "column", gap: 0 },
  navItem:  { display: "flex", alignItems: "center", gap: 8, padding: "7px 14px",
              border: "none", borderLeft: "2px solid transparent", background: "none",
              color: "var(--text)", cursor: "pointer", fontFamily: "Syne, sans-serif",
              fontSize: 11, fontWeight: 500, letterSpacing: "0.03em",
              textAlign: "left", width: "100%", opacity: 0.65 },
  navItemActive: { background: "var(--hover)", color: "var(--gold)",
                   borderLeft: "2px solid var(--gold)", paddingLeft: 12, opacity: 1 },
  navDot:   { width: 5, height: 5, borderRadius: "50%", flexShrink: 0 },
  sidebarFooter: { padding: "10px", borderTop: "0.5px solid var(--border)", marginTop: 4,
                   display: "flex", flexDirection: "column", gap: 6 },
  logoutBtn: { display: "flex", alignItems: "center", gap: 8, padding: "6px 10px",
               borderRadius: "5px", border: "0.5px solid var(--goldDim)", background: "none",
               color: "var(--goldDim)", cursor: "pointer", fontSize: 9,
               fontFamily: "Syne, sans-serif", letterSpacing: "0.1em",
               width: "100%", textTransform: "uppercase" },

  /* Page header */
  pageHeader: { display: "flex", alignItems: "flex-end", justifyContent: "space-between",
                paddingBottom: 24, borderBottom: "0.5px solid var(--border)" },
  pageEyebrow:{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 3,
                color: "var(--goldDim)", textTransform: "uppercase", marginBottom: 8 },
  pageH1:     { fontSize: 26, fontWeight: 700, color: "var(--text)", letterSpacing: "-0.5px", margin: 0 },

  /* Buttons */
  addBtn: { display: "flex", alignItems: "center", gap: 8, padding: "10px 20px",
            background: "none", border: "1px solid var(--gold)", color: "var(--gold)",
            borderRadius: T.r, cursor: "pointer",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: 12, fontWeight: 600, letterSpacing: 1.5, textTransform: "uppercase" },
  cancelBtn: { padding: "10px 18px", background: "var(--lift)", color: "var(--textSub)",
               border: "0.5px solid var(--border)", borderRadius: "8px",
               cursor: "pointer", fontSize: 13, fontFamily: "'Plus Jakarta Sans', sans-serif" },
  deleteBtn: { display: "flex", alignItems: "center", gap: 6, padding: "6px 12px",
               background: "none", border: `1px solid #3A1A1A`, color: "#6A3030",
               borderRadius: T.r, cursor: "pointer", fontSize: 11,
               fontFamily: "Plus Jakarta Sans, sans-serif", letterSpacing: 1, textTransform: "uppercase" },
  iconBtn:  { background: "none", border: "none", color: "var(--mute)",
              cursor: "pointer", padding: 4, borderRadius: 4,
              display: "flex", alignItems: "center" },
  genBtn:   { padding: "0 14px", background: "none", border: "0.5px solid var(--border)",
              color: "var(--gold)", borderRadius: "8px", cursor: "pointer", fontSize: 18 },
  eyeBtn:   { position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)",
              background: "none", border: "none", cursor: "pointer", color: "var(--mute)",
              display: "flex", alignItems: "center" },

  /* Search */
  searchWrap:  { display: "flex", alignItems: "center", gap: 10, background: "var(--card)",
                 border: "0.5px solid var(--border)", borderRadius: "8px", padding: "10px 16px",
                 boxShadow: "0 2px 8px rgba(0,0,0,0.25)" },
  searchInput: { flex: 1, background: "none", border: "none", color: "var(--text)",
                 fontFamily: "Syne, sans-serif", fontSize: 13, outline: "none" },

  /* Filter chips */
  chip:       { padding: "5px 14px", borderRadius: 999, border: "0.5px solid var(--border)",
                background: "none", color: "var(--textSub)", cursor: "pointer",
                fontFamily: "Syne, sans-serif", fontSize: 9, fontWeight: 600,
                letterSpacing: "0.1em", textTransform: "uppercase" },
  chipActive: { border: "0.5px solid var(--gold)", color: "var(--bgApp)",
                background: "var(--gold)", fontWeight: 700 },

  /* Credential card */
  credCard:   { background: "var(--card)", border: "0.5px solid var(--border)",
                borderRadius: "8px", overflow: "hidden", transition: "border-color 0.15s, box-shadow 0.15s",
                boxShadow: "0 2px 8px rgba(0,0,0,0.35), 0 1px 2px rgba(0,0,0,0.25)" },
  credHeader: { display: "flex", alignItems: "center", gap: 12,
                padding: "13px 16px", cursor: "pointer" },
  credIcon:   { width: 36, height: 36, background: "var(--lift)", border: "0.5px solid var(--border)",
                borderRadius: 8, display: "flex", alignItems: "center",
                justifyContent: "center", flexShrink: 0 },
  credName:   { fontFamily: "Syne, sans-serif", fontSize: 13, fontWeight: 600,
                color: "var(--text)", letterSpacing: 0.2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "100%" },
  credMeta:   { fontSize: 11, color: "var(--textSub)", marginTop: 2,
              fontFamily: "Syne, sans-serif", overflow: "hidden",
              textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "100%" },
  credBody:   { padding: "0 16px 16px", borderTop: "0.5px solid var(--border)" },
  credRow:    { display: "flex", alignItems: "center", gap: 12,
                padding: "9px 0", borderBottom: "0.5px solid var(--border)" },
  credLabel:  { width: 80, fontFamily: "Syne, sans-serif", fontSize: 10,
                letterSpacing: "0.1em", color: "var(--mute)", textTransform: "uppercase", flexShrink: 0 },
  credVal:    { flex: 1, fontSize: 13, color: "var(--textSub)", fontFamily: "Syne, sans-serif" },
  catTag:     { display: "inline-block", padding: "3px 10px", borderRadius: 999,
                background: "var(--lift)", border: "0.5px solid var(--border)",
                color: "var(--mute)", fontFamily: "Syne, sans-serif",
                fontSize: 8, letterSpacing: "0.1em", textTransform: "uppercase",
                fontWeight: 700 },

  /* Modal */
  overlay:     { position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)",
                 display: "flex", alignItems: "center", justifyContent: "center", zIndex: 100 },
  modal:       { background: "var(--card)", border: "0.5px solid var(--border)",
                 borderRadius: T.r, padding: 28, width: 460,
                 maxHeight: "90vh", overflow: "auto" },
  modalHeader: { display: "flex", alignItems: "flex-start", justifyContent: "space-between",
                 marginBottom: 24, paddingBottom: 20, borderBottom: "0.5px solid var(--border)" },
  modalTitle:  { fontSize: 18, fontWeight: 700, color: "var(--text)" },

  /* Form */
  formLabel: { display: "block", fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 9,
               letterSpacing: 2.5, color: "var(--mute)", textTransform: "uppercase", marginBottom: 8 },
  formInput: { width: "100%", background: "var(--lift)", border: "0.5px solid var(--border)",
               borderRadius: "8px", padding: "11px 14px", color: "var(--text)",
               fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 13,
               boxSizing: "border-box", outline: "none" },

  /* Empty */
  emptyState: { display: "flex", flexDirection: "column", alignItems: "center",
                justifyContent: "center", padding: "80px 0", gap: 8 },

  /* Toast */
  toast: { position: "fixed", bottom: 28, left: "50%", transform: "translateX(-50%)",
           background: "var(--card)", border: "1px solid var(--goldDim)", color: "var(--gold)",
           padding: "11px 22px", borderRadius: T.r, fontSize: 12,
           fontFamily: "Plus Jakarta Sans, sans-serif", letterSpacing: 1.5,
           textTransform: "uppercase", zIndex: 200 },
};
